"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalListsNotMarkedDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdditionalListsNotMarkedDescription = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.additional_lists_not_marked_description.label',
    fallbackLabel: 'Please list the additional sanction lists that are used for name and transaction sanction screening.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.sanction_lists', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (!!payload.mor_group_answers?.sanction_lists && payload.mor_group_answers?.sanction_lists.filter(value => value.valueOf?.() === 'ADDITIONAL_AUTONOMOUS_LISTS').length != 0)
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (!!payload.mor_group_answers?.sanction_lists && payload.mor_group_answers?.sanction_lists.filter(value => value.valueOf?.() === 'ADDITIONAL_AUTONOMOUS_LISTS').length != 0)
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
